import { render } from "./UserRate.vue?vue&type=template&id=8e17d1fc&scoped=true"
import script from "./UserRate.vue?vue&type=script&lang=js"
export * from "./UserRate.vue?vue&type=script&lang=js"

import "./UserRate.vue?vue&type=style&index=0&id=8e17d1fc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e17d1fc"]])

export default __exports__